export enum EntityType {
    AUDIENCE = "AUDIENCE",
    CONTENT_APP = "CONTENT_APP",
    DATA_PROVIDER = "DATA_PROVIDER"
}